import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import _filter from "ramda/src/filter";
import _prop from "ramda/src/prop";
import _mapObjIndexed from "ramda/src/mapObjIndexed";
import _values from "ramda/src/values";
import _pipe from "ramda/src/pipe";
import Color from 'color';
import { assert, isNumber, deprecate } from '../common/utils';
export var rawColor = {
  brandBlue: '#00C8F5',
  brandGreen: '#D2F500',
  brandPink: '#FF2B83',
  brandTurquoise: '#00F0E1',
  complementaryBlue1: '#385E9D',
  complementaryBlue2: '#131F4F',
  complementaryGreen1: '#3A913F',
  complementaryGreen2: '#023C00',
  complementaryPink1: '#AC135A',
  complementaryPink2: '#78013A',
  complementaryTurquoise1: '#009195',
  complementaryTurquoise2: '#01424C',
  black: '#000000',
  gray0: '#282823',
  gray1: '#4B4B46',
  gray2: '#6E6E69',
  gray3: '#A0A09B',
  gray4: '#BCBCB6',
  gray5: '#D7D7D2',
  gray6: '#EBEBE8',
  gray7: '#F5F5F5',
  white: '#FFFFFF',
  cta: '#0046FF',
  positive: '#00D200',
  negative: '#FF1900',
  index: '#FFCF00',
  a11yCta: '#2D67FF',
  a11yPositive: '#008A00',
  a11yNegative: '#E81700',
  a11yIndex: '#C15700'
};
var breakpoints = {
  sm: {
    size: 760,
    offset: 5
  },
  md: {
    size: 976,
    offset: 5
  },
  lg: {
    size: 1280,
    offset: 5
  },
  xl: {
    size: 1600,
    offset: 5
  }
};
var size = {
  xs: 360,
  sm: 760,
  md: 976,
  lg: 1280,
  xl: 1600
};

var getSizesValues = _pipe(_mapObjIndexed(_prop('size')), _values, _filter(Boolean));

export var createTheme = function createTheme() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$a11yColors = config.a11yColors,
      a11yColors = _config$a11yColors === void 0 ? false : _config$a11yColors;
  var sizeValues = getSizesValues(breakpoints);
  var GUTTER = 5;
  var UNIT = 4;

  var unit = function unit(times) {
    return times * UNIT;
  };

  unit.valueOf = function () {
    return UNIT;
  };

  unit.toString = function () {
    return UNIT.toString();
  };

  var spacing = {
    unit: unit,
    gutter: GUTTER
  };
  var theme = {
    animation: {
      easing: {},
      duration: {}
    },
    breakpoints: breakpoints,
    color: {
      backgroundInput: rawColor.white,
      background: rawColor.gray7,
      backgroundDark: rawColor.gray0,
      buttonSecondaryBackground: rawColor.white,
      buttonText: rawColor.white,
      buy: a11yColors ? rawColor.a11yCta : rawColor.cta,
      borderActive: a11yColors ? rawColor.a11yCta : rawColor.cta,
      card: rawColor.white,
      cta: a11yColors ? rawColor.a11yCta : rawColor.cta,
      disabled: rawColor.gray3,
      disabledText: rawColor.gray3,
      disabledBackground: rawColor.gray6,
      divider: rawColor.gray6,
      label: rawColor.gray2,
      selectOptionBackground: rawColor.white,
      modalBackdrop: Color(rawColor.gray2).alpha(0.63).rgb().string(),
      module: rawColor.white,
      negative: a11yColors ? rawColor.a11yNegative : rawColor.negative,
      positive: a11yColors ? rawColor.a11yPositive : rawColor.positive,
      sell: a11yColors ? rawColor.a11yNegative : rawColor.negative,
      shadowCard: Color(rawColor.black).alpha(0.03).rgb().string(),
      shadowModal: Color(rawColor.black).alpha(0.05).rgb().string(),
      shadowInput: Color(rawColor.black).alpha(0.03).rgb().string(),
      shadowSwitch: Color(rawColor.black).alpha(0.05).rgb().string(),
      spinnerBlack: rawColor.black,
      spinnerWhite: rawColor.white,
      svgFill: rawColor.gray0,
      svgStroke: rawColor.gray2,
      text: rawColor.gray0,
      textLight: rawColor.white,
      warning: a11yColors ? rawColor.a11yIndex : rawColor.index,
      inputBorder: rawColor.gray4,
      inputBorderHover: rawColor.gray1,
      flagBorder: rawColor.gray6,
      inputBorderError: rawColor.negative,
      inputBorderSuccess: rawColor.positive,
      generationSavingsTimelineColor1: rawColor.complementaryGreen1,
      generationSavingsTimelineColor2: rawColor.complementaryPink1,
      generationSavingsTimelineColor3: rawColor.brandBlue,
      generationSavingsTimelineColor4: rawColor.complementaryBlue1
    },
    media: {
      between: function between(s1, s2) {
        var number1 = isNumber(s1) ? s1 : s1.size;
        var number2 = isNumber(s2) ? s2 : s2.size;
        assert(sizeValues.includes(number1), "[theme.media] Unrecognized size value: ".concat(number1));
        assert(sizeValues.includes(number2), "[theme.media] Unrecognized size value: ".concat(number2));
        return "@media (min-width: ".concat(number1, "px) and (max-width: ").concat(number2 - 1, "px)");
      },
      greaterThan: function greaterThan(s) {
        var number = isNumber(s) ? s : s.size;
        assert(sizeValues.includes(number), "[theme.media] Unrecognized size value: ".concat(number));
        return "@media (min-width: ".concat(number, "px)");
      },
      lessThan: function lessThan(s) {
        var number = isNumber(s) ? s : s.size;
        assert(sizeValues.includes(number), "[theme.media] Unrecognized size value: ".concat(number));
        return "@media (max-width: ".concat(number - 1, "px)");
      }
    },
    size: deprecate('theme.size, please use theme.breakpoint instead.')(size),
    spacing: spacing
  };
  return theme;
};